import Vue from 'vue';
import { convertDateToDdMmYyyy } from '@/function/function.js';
import EnteteBonEtFacture from '@/views/en-tete-bon-facture';
import EnteteA5 from '@/views/entete-a5';

import VueHtml2pdf from 'vue-html2pdf'
Vue.use(VueHtml2pdf)

export default {
    name: 'ordonnance-medicale',

    components: {
        VueHtml2pdf, EnteteBonEtFacture,
        EnteteA5
    },
    props: [
        "consultation_id", "is_printable"
    ],
    data () {
        return {
            date_resultat: '',           //  Date d'enregistrement du résultat
            prescripton_length: 0,
            format_ordonnace: 'a5',       //  A5 (si prescriptions <= 6 ) ou A4 ( si prescription > 6)
            width_ordonnance: '559px',
            font_size: 'font-14',

            filename: '',
            
            loading: true,
            ord_is_loading: true,
            ord_is_empty: false,
        }
    },
    computed: {
       
        ordonnance_historique() {
            return this.$store.getters["consultationOrdonnanceHistorique"];
        },

        patient(){
            return this.$store.getters['patient'];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        getPrescriptionLength() {
            let len  = 0
            if(this.ordonnance_historique.length > 0) {
                len = this.ordonnance.prescriptons.length
            }
            return len
        },
    },
    mounted () {
        this.date_resultat = convertDateToDdMmYyyy.convertDate(new Date());  // Temporaire. NB : A remplacer par la date du resultat
        
        let t = new Date()
        this.filename = 'Ordonnance_'+this.patient.nom+' '+this.patient.prenoms+'_'+t.getTime()

        this.refreshOrdonnance()
    },
    methods: {
        refreshOrdonnance() {
            this.ord_is_loading = true
            let data = {
                enCours: false,
                id: this.consultation_id
            }
            this.$store.dispatch('getConsultationOrdonnance', data).then(() => {
                if (this.ordonnance_historique.prescriptions.length > 0) {
                    this.ord_is_empty = false
                } else {
                    this.ord_is_empty = true 
                }

                this.ord_is_loading = false
            })
        },

        setPdfFormat() {
            
            if (this.ordonnance_historique.length <= 6) {
                this.format_ordonnace = 'a5'
                this.width_ordonnance = '559px'
                this.font_size = 'font-14'
            } else if(this.ordonnance_historique.length <= 8) {
                this.format_ordonnace = 'a5'
                this.width_ordonnance = '559px'
                this.font_size = 'font-10'
            } else {
                this.format_ordonnace = 'a4'
                this.width_ordonnance = '800px'
                this.font_size = 'font-16'
            }

        },

        async printOrdonnance() {
            await this.setPdfFormat()
          
            this.$refs.ordonnance_html2Pdf.generatePdf()
        },

        async beforeDownload ({ html2pdf, options, pdfContent }) {
            await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                // const totalPages = pdf.internal.getNumberOfPages()

                let foot_content = 'Généré(e) via l\'application Clinicaa';

                let la_medecin = 'Le Médecin';
                let lome_le = this.ville_le+this.date_resultat;

                if(this.format_ordonnace == 'a5') {
                    // LOME LE
                    pdf.setTextColor(150)
                    pdf.setFontSize(8)
                    pdf.text(lome_le, (0.5), (pdf.internal.pageSize.getHeight() - 1))

                    // LA CAISSE
                    pdf.setTextColor(150)
                    pdf.setFontSize(8)
                    pdf.text(la_medecin, (4.7), (pdf.internal.pageSize.getHeight() - 1))

                    // FOOTER
                    pdf.setTextColor(150)
                    pdf.setFontSize(6)
                    pdf.text(foot_content, (2.3), (pdf.internal.pageSize.getHeight() - 0.1))
                } else {
                    // LOME LE
                    pdf.setTextColor(150)
                    pdf.setFontSize(10)
                    pdf.text(lome_le, (0.5), (pdf.internal.pageSize.getHeight() - 1.4))

                    // LA CAISSE
                    pdf.setTextColor(150)
                    pdf.setFontSize(10)
                    pdf.text(la_medecin, (7), (pdf.internal.pageSize.getHeight() - 1.4))

                    // FOOTER
                    pdf.setTextColor(150)
                    pdf.setFontSize(6)
                    pdf.text(foot_content, (3.333858), (pdf.internal.pageSize.getHeight() - 0.3))
                }
                
            }).save()
        },

        onProgress(ev) {
            console.log(ev)
        },  
        
        hasStartedGeneration() {
            
        },  
 
        hasGenerated(ev) {
            console.log(ev)
        }
    }
}


